import store from '@/store'


//获取地址栏参数
export const getUrlParams = (key) => {
    const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}

//校验按钮权限
export const getPermission = (str) => {
    const { equityInformation: { permissionList } } = store.state
    if (permissionList && JSON.stringify(permissionList).indexOf(str) !== -1) {
        return true
    } else {
        return false
    }
}

/**
 * 获取 YYYYMMDD 格式的日期字符串
 * @param {Date} [date=new Date()] - 可选，指定日期，默认当前日期
 * @returns {String} 如 "20260317"
 */
export const getDateStr = (date = new Date()) => {
    // 获取年（4位）
    const year = date.getFullYear()
    // 获取月（补前导0，1月是0，所以要+1）
    const month = String(date.getMonth() + 1).padStart(2, '0')
    // 获取日（补前导0）
    const day = String(date.getDate()).padStart(2, '0')
    // 拼接成 YYYYMMDD
    return year + month + day
}
